import { Component } from '@angular/core';
import { UserService } from './shared/services/user.service';
import { ActivatedRoute,NavigationEnd, Router } from '@angular/router';
import { JwtToken } from './shared/models/jwt-token';
import { UserDetails } from './shared/models/user-details';
import { CommonService } from './shared/services/common.service';
import { JwtHelperService } from './shared/services/jwt-helper.service';
import { filter } from 'rxjs';
import { SignalrService } from './shared/services/signalr.service';

@Component({
    selector: 'xp-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    title = 'XPresslegal Integration';
    userDetails: UserDetails | undefined;
    isViewDocument: boolean = false;
    showProgressBar: boolean = true;

    constructor(
        public userService: UserService,
        public jwtService: JwtHelperService,
        private router: Router,
        private commonService: CommonService,
        private route: ActivatedRoute,
        private signalRService: SignalrService
    ) {}
    
    ngOnInit(): void {
        const pathName: string = window.location.pathname;
        const numberRegex: RegExp = /\d+/;
        const match: RegExpMatchArray | null = pathName.match(numberRegex);
        if (match !== null) {
            sessionStorage.setItem("matterId", match[0]);
        }
        if (!this.userDetails && localStorage.UserDetails) {
            this.userDetails = JSON.parse(localStorage.UserDetails);
            this.userService.userDetails = this.userDetails;
        }
        this.userService.userSubjectChanged.subscribe(userData => {
            if (userData) {
                this.userDetails = userData;
            }
        });
        this.refreshToken()

        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.route.queryParams.subscribe(params => {
                this.showProgressBar = params['code'] ? true : false;
            });
        });

        this.signalRService.startConnection();
        this.MultiTabsLogOut();
    }

    MultiTabsLogOut() {
        window.addEventListener('storage', (event) => {
            if (event.key === 'LOGOUT') {
                localStorage.clear();
                sessionStorage.clear();
                window.location.reload();
            }
        });
    }


    refreshToken() {
        setTimeout(async () => {
            let token = this.commonService.decrypt(localStorage.getItem("token")!);
            try {
                if (token) {
                    var expiry = new Date(this.jwtService.decodeToken(token)?.exp! * 1000);
                    if ((expiry.getTime() - 300000) <= (new Date().getTime())) {
                        let response = await this.userService.refreshToken();
                        if (response && response.success) {
                            let userData: JwtToken | undefined = this.jwtService.decodeToken(response.token!);
                            let LoggedUserRole = await this.userService.getCurrentUserRole();
                            if (userData) {
                                this.userService.userDetails = {
                                    code: userData.sub,
                                    fullName: userData.name,
                                    userName: userData.sub,
                                    avatar: userData.name.charAt(0)?.toUpperCase() ?? "U",
                                    userRole: LoggedUserRole,
                                    activeDirectoryLink: userData.userGuid,
                                    userEmail: userData.email,
                                    tenantId: userData.tenantId
                                };
                                this.userService.userDetails.avatar = userData.name.charAt(0)?.toUpperCase() ?? "";
                                this.userService.isAutherized = true;
                                localStorage.setItem("userDetails", JSON.stringify(this.userService.userDetails));
                            }
                        } else {
                            localStorage.clear();
                            this.userService.isAutherized = false;
                            this.userService.userDetails = undefined;
                            this.userService.userSubjectChanged.next(null);
                            this.router.navigate(['/unauthorised']);
                        }
                    }
                }
                this.refreshToken();
            } catch (error) {
                this.userService.userDetails = undefined;
                this.userService.isAutherized = false;
                this.userService.userSubjectChanged.next(null);
                this.router.navigate(['/unauthorised']);
            }
        }, 5000);
    }
}
